module.exports = __webpack_public_path__ + "static/media/handwritten.26f9e641.png";